import React from "react";
import { Route, Redirect } from "react-router-dom";

function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const IsAdmin = () => {
  const userStr = localStorage.getItem("user");
  if (!isJsonString(userStr)) return false;
  const user = JSON.parse(userStr);
  return user && user.token && user.tipoCuenta === 0;
};

function AdminRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        IsAdmin() ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/home",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

export default AdminRoute;
